import _, { range } from "lodash";
import moment from "moment";
import { timezoneArea, timezoneTagName } from "./AppUtils";
import { event } from "jquery";

export const formatCalendarData = (calenderSessionListArray, userDetails, authBroker) => {
    let events = range(0, 6).map(() => [])
    // for (let calendarData of calenderSessionListArray) {
        if (calenderSessionListArray.status === 'success') {
            const sessionData = _.clone(calenderSessionListArray.payload.payload);
            console.log('livesessions sessionData Calendar List Array', sessionData)
            if (_.isArray(sessionData) && !_.isEmpty(sessionData)) {
                let api_date_format = "YYYY-MM-DD HH:mm"
                const userTz = moment.tz.guess();
                const timezoneOffset = !_.isEmpty(userDetails?.timezone) ? userDetails?.timezone.replace(':', '') : '-0500'
                const area = timezoneArea(timezoneOffset)
                for (let session of sessionData) {
                    const actualTimezoneOffset = session.timezone.includes(':') ? session.timezone.replace(":", "") : "-0500";
                    const actualArea = timezoneArea(actualTimezoneOffset)
                    // console.log('event session Calendar List Array', session)
                    if (_.isArray(session.date_time)) {
                        let startDate = session?.first_start_date_time?.split(' ')[0]
                        let startTime = session?.first_start_date_time?.split(' ')[1]
                        let endDate = session?.last_end_date_time?.split(' ')[0]
                        let endTime = session?.last_end_date_time?.split(' ')[1]
                        let sessionStartDate = moment.utc(
                            startDate?.replaceAll("-", "/") +
                            " " +
                            startTime
                            // ).utcOffset(actualTimezoneOffset);
                        ).tz(actualArea);
                        let sessionEndDate = moment.utc(
                            endDate?.replaceAll("-", "/") +
                            " " +
                            endTime
                            // ).utcOffset(actualTimezoneOffset);
                        ).tz(actualArea);
                        for (let event_time of session.date_time) {
                            // const startDateTime = moment.utc(event_time?.start_date?.replaceAll('-', '/') + ' ' + event_time.start_time).utcOffset(timezoneOffset);
                            // const endDateTime = moment.utc(event_time?.end_date?.replaceAll('-', '/') + ' ' + event_time.end_time).utcOffset(timezoneOffset);
                            const startUTC = event_time?.start_date?.replaceAll('-', '/') + ' ' + event_time.start_time;
                            const endUTC = event_time?.end_date?.replaceAll('-', '/') + ' ' + event_time.end_time;
                            // console.log('START UTC', startUTC)
                            const startDateTime = moment.utc(startUTC).tz(area);
                            const endDateTime = moment.utc(endUTC).tz(area);
                            // const currentDateTime = moment();
                            // const currentDateTime = moment().utcOffset(timezoneOffset);
                            const currentDateTime = moment().tz(area);
                            const weekDay = startDateTime?.day()
                            const startTense = getTense(getTenseDiff(moment.duration(startDateTime?.diff(currentDateTime)).asDays()));
                            const endTense = getTense(getTenseDiff(moment.duration(endDateTime?.diff(currentDateTime)).asDays()));
                            const tense = startTense === 'past' && endTense === 'past' ? 'past' : endTense
                            // console.log('eventsData', session.session_name, event_time.is_host, tense, endDateTime, moment.duration(startDateTime.diff(currentDateTime)).asDays(), event_time)
                            if (tense !== 'past' || (tense === 'past' && session.is_registered)) {
                                if (!isNaN(weekDay)) {
                                    let data = {
                                        startTense: startTense,
                                        endTense: endTense,
                                        startUTC: startUTC,
                                        endUTC: endUTC,
                                        start: moment(startDateTime?.format(api_date_format)).toDate(),
                                        end: moment(endDateTime?.format(api_date_format)).toDate(),
                                        durationValue: _.toInteger(moment.duration(endDateTime?.diff(startDateTime)).asMinutes()),
                                        duration: _.toInteger(moment.duration(endDateTime?.diff(startDateTime)).asMinutes()) + 'mins',
                                        tense: tense,
                                        tenseDayDiff: getTenseDiff(moment.duration(startDateTime?.diff(currentDateTime)).asDays()),
                                        // timezone: moment.tz(userTz).format('z'),
                                        timezone: '', //timezoneTagName(zoneAbbr),
                                        actualTimezoneAbbr: sessionStartDate.format('z'), //timezoneTagName(session.timezoneAbbr),
                                        title: session.session_name,
                                        channel: session.channel_name,
                                        author: session.instructor,
                                        meetingId: event_time.meeting_id,
                                        sessionId: session.session_id,
                                        eventId: session.event_id,
                                        eventCode: session.event_code, //added
                                        userId: authBroker?.payload?.user?.user_id,
                                        id: events.length,
                                        source: session.source === 'ecom' ? 'xsel' : 'broker',
                                        is_addToCart: session.is_addtocart,
                                        is_registered: session.is_registered,
                                        is_paid: (event_time.is_host || event_time.is_instructor) ? true : session.is_paid,
                                        is_cancelled: session.is_cancelled,
                                        is_expired: event_time.is_expired,
                                        is_completed: event_time.is_completed,
                                        is_live: event_time.is_live,
                                        watch_url: event_time.watch_url,
                                        selling_price: (event_time.is_host || event_time.is_instructor || _.isEmpty(session.purchased_info)) ? 0 : session.purchased_info?.selling_price,
                                        productId: session.product_id,
                                        segmentId: event_time.segment_id,
                                        is_host: event_time.is_host,
                                        is_boardcast: session.delivery_mode != 'virtual_interactive' ? true : false,
                                        is_participant: (event_time.is_instructor && !event_time.is_host) ? true : event_time.is_participant,
                                        hostZoomId: authBroker?.payload.user.zoom_id,
                                        start_url: event_time.start_url ? event_time.start_url : '',
                                        join_url: event_time.join_url ? event_time.join_url : '',
                                        current_time: currentDateTime?.format(api_date_format),
                                        sessionStartDate: moment(
                                            sessionStartDate.format(api_date_format)
                                        ).toDate(),
                                        sessionEndDate: moment(
                                            sessionEndDate.format(api_date_format)
                                        ).toDate(),
                                        delivery_mode: session.delivery_mode,
                                        location: session.location,
                                        showRegister: sessionStartDate.isSameOrAfter(currentDateTime),
                                        cross30: currentDateTime.isSameOrBefore(moment(sessionStartDate).clone().add(30, 'minutes')),
                                        cross30Time: moment(sessionStartDate).clone().add(30, 'minutes').format(api_date_format),
                                        beforeEndTime: currentDateTime.isSameOrBefore(endDateTime),
                                        isSegmentFirst: sessionStartDate.isSame(startDateTime),
                                        profileTz: currentDateTime.format('z'),
                                        provider : session?.provider, //added
                                        eventThumbnail : session?.event_thumbnail,
                                        eventDesc : session?.event_desc, 
                                    
                                    }
                                    console.log('Calendar List Array Individual', data,weekDay, events[weekDay])
                                    try {
                                        events[weekDay].push(data)
                                    } catch (e) {
                                        console.log(e)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    // }

    return events;
}

const getTense = (diff) => {
    if (diff > 0) {
        return "future"
    } else if (diff < 0) {
        return "past"
    } else {
        return "present"
    }
}

const getTenseDiff = (value) => {
    if (value > 1) {
        return 1;
    } else if (value <= 0) {
        return -1;
    } else {
        return 0;
    }
}